var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6583 21.9063C42.6583 28.3124 41.0624 32.6208 34.7946 38.378C34.6773 38.4874 21.4844 49.7131 21.4844 49.7131C21.4844 49.7131 8.2363 38.2971 8.11895 38.1877C3.32597 33.973 0.318359 28.3124 0.318359 21.9063C0.318359 10.2126 9.79849 0.740234 21.4844 0.740234C33.1781 0.740234 42.6583 10.2126 42.6583 21.9063Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5642 38.6094C30.8763 38.6094 38.4253 31.0604 38.4253 21.7483C38.4253 12.4362 30.8763 4.88721 21.5642 4.88721C12.2521 4.88721 4.70312 12.4362 4.70312 21.7483C4.70312 31.0604 12.2521 38.6094 21.5642 38.6094Z",
    fill: "#A2DB67",
    stroke: "#55990E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5129 28.0424C16.954 26.7181 13.4008 26.6193 9.75586 27.6939C9.80615 26.6601 9.84885 25.6694 9.90351 24.6794C10.0796 21.4898 10.2662 18.3009 10.4298 15.1108C10.4467 14.7811 10.5564 14.6085 10.843 14.4585C13.4152 13.1127 16.0441 13.206 18.6973 14.1513C19.3026 14.3669 20.0437 14.5557 20.3983 15.0098C20.6866 15.379 20.5048 16.1268 20.5059 16.7067C20.5122 20.2972 20.5114 23.8878 20.5129 27.4783C20.513 27.648 20.5129 27.8178 20.5129 28.0424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.459 28.0476C22.459 27.8387 22.459 27.6979 22.459 27.5571C22.4607 23.5078 22.4595 19.4585 22.4737 15.4092C22.4744 15.2232 22.5619 14.9361 22.6967 14.8667C25.4809 13.4344 28.3476 12.9314 31.3774 14.0918C32.1803 14.3993 32.5717 14.7967 32.6014 15.7429C32.7014 18.9349 32.922 22.1232 33.0957 25.3129C33.1377 26.0843 33.1768 26.8558 33.2206 27.6912C29.5892 26.6285 26.0396 26.7082 22.459 28.0476Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3399,
    height: 48.9729,
    fill: "white",
    transform: "translate(0.318359 0.740234)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.b71fcd7de3932121a192fda36e5eb5fd.svg";
export { ForwardRef as ReactComponent };